import * as React from 'react';
import { Route, IndexRoute } from '@reverbdotcom/commons/dist/route_settings';

const ShopRoutes = (
  <Route
    key="shop/:shop"
    path="shop/:shop"
    getComponent={(_location, cb) => {
      require.ensure(
        [],
        (require) => {
          cb(null, require('../components/discovery/shops/shop_container').default);
        },
        'shop',
      );
    }}
  >
    <IndexRoute
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../components/marketplace/shop_page').default);
          },
          'shop',
        );
      }}
    />
    <Route
      key="feedback"
      path="feedback"
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../components/discovery/shops/shop_feedback').default);
          },
          'shop',
        );
      }}
    />
    <Route
      key="about"
      path="about"
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../components/discovery/shops/shop_info').default);
          },
          'shop',
        );
      }}
    />
  </Route>
);

export {
  ShopRoutes,
};



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/routes/shop.tsx